/** Bosh sahifa (demo v3 `Home`, `greet`, `langSheet`, `NotifSheet`): brend, salom, streak/XP/reyting, bugungi dars, tez amallar, so'z shakllari, so'z jangi. Tab ichida. */
import { useEffect, useState } from 'react';
import { LANG, LN, shuffle } from '../data';
import { useStore, newToday, unseen, hardWords, streakNow, activeSet, st, switchCourse, today } from '../store';
import { FM } from '../data/forms';
import { Brand } from '../ui/Brand';
import { LetterAvatar, MyAvatar } from '../ui/Avatar';
import { sync, type ApiDuel } from '../lib/sync';
import { nav } from '../lib/nav';
import { toast } from '../lib/toast';
import { startLesson, startPractice, clampGoal, lessonNewLeft, extraNewLeft } from './lesson/engine';
import { t, tn } from '../i18n';
import { Ic } from '../ui/Icon';
import { SheetBox } from '../ui/Sheet';
import { CourseBtns } from './Onboarding';
import { fetchRank, myRank } from './Rank';
import { useSetsUi } from './Sets';

export function greet() { const h = new Date().getHours(); return h < 5 ? 'Xayrli tun' : h < 11 ? 'Xayrli tong' : h < 17 ? 'Xayrli kun' : 'Xayrli kech'; }

/** Demo `langSheet` — o'rganilayotgan tilni almashtirish varag'i. */
export function LangSheet({ onClose }: { onClose: () => void }) {
  return (
    <div className="lsh" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <SheetBox title={t('Qaysi tilni oʻrganasiz?')} onClose={onClose} label={t('Tilni tanlang')}>
        <div className="col g10"><CourseBtns onPick={(k) => { if (k === LANG) return onClose(); switchCourse(k); }} /></div>
        <span className="t12">{t('Har bir tilning progressi alohida saqlanadi.')}</span>
      </SheetBox>
    </div>
  );
}

const C = 2 * Math.PI * 37;

/** Bildirishnomalar markazi (demo v3 `NotifSheet`; Pro eslatmalarisiz): kunlik dars, streak, so'z jangi natijalari. */
function NotifSheet({ onClose }: { onClose: () => void }) {
  const left = unseen().length ? lessonNewLeft() : 0, stk = streakNow();
  const [duels, setDuels] = useState<ApiDuel[]>([]);
  useEffect(() => { sync.duels().then((r) => setDuels(r.duels)).catch(() => {}); }, []);
  const items: Array<[string, string, string, string, () => void]> = [];
  if (left) items.push(['book', 'info', tn('Bugun yana # ta yangi soʻz', left), t('Kunlik maqsadni bajaring — 5 daqiqa yetadi.'), () => startLesson()]);
  if (stk) items.push(['flame', 'peach', tn('# kunlik streak', stk), t('Bugungi darsni qilsangiz, streak davom etadi.'), () => startLesson()]);
  for (const d of duels.slice(0, 5)) {
    const opp = d.opp.player ? (d.opp.player.nick ? '@' + d.opp.player.nick : d.opp.player.n) : null;
    const open = () => nav.push({ k: 'duel', code: d.code });
    if (d.status === 'done') {
      const r = d.result === 'win' ? t('Gʻalaba!') : d.result === 'draw' ? t('Durang') : t('Bu safar raqib yutdi');
      items.push(['swords', d.result === 'win' ? 'success' : 'primary', `${t('Soʻz jangi')}: ${r}`, `${opp ?? ''} · ${d.me.score ?? 0} : ${d.opp.score ?? 0}`, open]);
    } else if (d.status === 'ready' && d.opp.score != null) {
      items.push(['swords', 'peach', t('Sizni jangga chaqirishdi'), `${opp ?? ''} · ${t('Javob bering')}`, open]);
    } else if (d.status === 'waiting' || d.status === 'open') {
      items.push(['swords', 'info', t('Raqib natijasi kutilmoqda'), opp ? opp : t('Doʻstingiz hali qoʻshilmadi'), open]);
    }
  }
  return (
    <div className="lsh" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <SheetBox title={t('Bildirishnomalar')} onClose={onClose}>
        <div className="col g8" style={{ maxHeight: '70vh', overflow: 'auto' }}>
          {items.length ? items.map(([i, c, ti, d, go], k) => (
            <button key={k} className="ntf" onClick={() => { onClose(); go(); }}>
              <span className="sq2" style={{ background: `var(--${c}-soft)`, color: `var(--${c}-ink)` }}><Ic n={i} /></span>
              <span className="grow col g4" style={{ textAlign: 'left' }}><b className="t15b">{ti}</b><span className="t13">{d}</span></span>
            </button>
          )) : <span className="t13">{t('Yangi bildirishnoma yoʻq')}</span>}
        </div>
      </SheetBox>
    </div>
  );
}

export function Home() {
  const s = useStore(); // butun holatga obuna (selektorlar uchun)
  const [lang, setLang] = useState(false);
  const [notif, setNotif] = useState(false);
  const [, setTick] = useState(0);

  const nt = newToday(), goal = clampGoal(s.goal), nl = unseen().length;
  const left = Math.max(0, goal - nt);
  const can = left > 0 && nl > 0, pct = Math.min(1, nt / goal);
  /** Maqsad bajarildi — «Yana o'rganish» darsi hajmi (0 — kunlik limit yoki so'z tugadi). */
  const more = !left ? Math.min(extraNewLeft(), nl) : 0;
  const hw = hardWords(); const rk = myRank('week');
  useEffect(() => { fetchRank('week').then(() => setTick((x) => x + 1)); }, []);
  const fDue = FM.items.filter((x) => s.fw[x.id] && s.fw[x.id]!.due <= today()).length;
  const fLearned = FM.items.filter((x) => (s.fw[x.id]?.box ?? 0) >= 3).length;
  const aset = activeSet();
  const fromCard = s.mode === 'center' && !!aset && aset.ids.some((id) => !st(id));
  const heroT = !can ? (left ? t('Yangi soʻz qolmadi') : t('Bugungi reja bajarildi')) : tn('# ta soʻz qoldi', left);
  const heroS = !can ? (nl ? (more ? t('Xohlasangiz, yana davom eting') : tn('Ertaga yana # ta yangi soʻz', goal)) : t('Barcha soʻzlar oʻrganildi')) : fromCard ? t('Joriy kartochkadan') : tn('Kunlik maqsad: # ta soʻz', goal);
  const name = s.name;

  return (
    <>
      <Brand />
      <div className="row g10" style={{ marginTop: -6 }}>
        <div className="grow col"><span className="t13" style={{ fontSize: 14, fontWeight: 500 }}>{t(greet())}</span><b style={{ fontSize: 24, lineHeight: '32px', fontWeight: 800 }}>{name || t('Lexo oʻquvchisi')}</b></div>
        <button className="langchip" aria-label={t('Tilni almashtirish')} onClick={() => setLang(true)}>{LN.code}<Ic n="chevDown" size={14} /></button>
        <button className="sq2 card" aria-label={t('Bildirishnomalar')} onClick={() => setNotif(true)}><Ic n="bell" size={20} />{can && <i className="reddot" />}</button>
        <button className="sq2 avbtn" aria-label={t('Profil')} onClick={() => nav.tab('profile')}><MyAvatar size={44} /></button>
      </div>
      <div className="strip">
        <span style={{ background: 'var(--peach-soft)', color: 'var(--flame)' }}><Ic n="flame" size={16} style={{ fill: '#FFC629' }} />{tn('# kun', streakNow())}</span>
        <span style={{ background: 'var(--primary-soft)', color: 'var(--primary-ink)' }}><Ic n="zap" size={16} style={{ fill: '#B9D1FF' }} />{tn('# XP', s.xp)}</span>
        <button style={{ background: 'var(--success-soft)', color: 'var(--success-ink)' }} onClick={() => nav.push({ k: 'rank' })}><Ic n="trophy" size={16} />{tn('#-oʻrin', rk.me)}</button>
      </div>
      <section className="hero2">
        <Ic n="book" style={{ position: 'absolute', right: -20, top: -24, width: 130, height: 130, opacity: .1, stroke: '#fff' }} />
        <div className="row" style={{ gap: 16 }}>
          <div className="ring2">
            <svg viewBox="0 0 84 84" width="84" height="84">
              <circle cx="42" cy="42" r="37" fill="none" stroke="rgba(255,255,255,.25)" strokeWidth="10" />
              <circle cx="42" cy="42" r="37" fill="none" stroke="#FFC629" strokeWidth="10" strokeLinecap="round" strokeDasharray={C} strokeDashoffset={C * (1 - pct)} />
            </svg>
            <b>{nt}/{goal}</b>
          </div>
          <div className="col g4">
            <span style={{ fontSize: 11, fontWeight: 800, opacity: .75, letterSpacing: '.06em' }}>{t('BUGUNGI DARS')}</span>
            <b style={{ fontSize: 20, lineHeight: '26px' }}>{heroT}</b>
            <span style={{ opacity: .82, fontSize: 13, fontWeight: 500 }}>{heroS}</span>
          </div>
        </div>
        {can || !more ? (
          <button className="cta2" disabled={!can} onClick={() => startLesson()}>
            {can ? (nt ? t('Darsni davom ettirish') : t('Darsni boshlash')) : t('Bugun tugadi')} <Ic n="play" size={14} style={{ fill: 'currentColor' }} />
          </button>
        ) : (
          <button className="cta2" id="more" onClick={() => startLesson(true)}>
            {tn('Yana # ta soʻz oʻrganish', more)} <Ic n="play" size={14} style={{ fill: 'currentColor' }} />
          </button>
        )}
      </section>
      {s.mode === 'center' && (aset ? (
        <button className="qa2" onClick={() => { useSetsUi.getState().set({ segT: 'mine' }); nav.tab('sets'); }}>
          <span className="sq2" style={{ background: 'var(--peach-soft)', color: 'var(--peach-ink)' }}><Ic n="book" /></span>
          <span className="grow col g4" style={{ textAlign: 'left' }}><b className="t15b">{aset.name}</b><span className="t13">{tn('Joriy kartochka · #/# oʻrganildi', aset.ids.filter((id) => st(id)).length, aset.ids.length)}</span></span>
          <span className="chev2"><Ic n="chevRight" size={16} /></span>
        </button>
      ) : (
        <button className="qa2" onClick={() => nav.push({ k: 'setEditor', id: null })}>
          <span className="sq2" style={{ background: 'var(--primary-soft)', color: 'var(--primary-ink)' }}><Ic n="book" /></span>
          <span className="grow col g4" style={{ textAlign: 'left' }}><b className="t15b">{t('Dars kartochkasi')}</b><span className="t13">{t('Ixtiyoriy: darsdagi soʻzlarni qoʻshing')}</span></span>
          <span className="chev2"><Ic n="chevRight" size={16} /></span>
        </button>
      ))}
      <button className="qa2" onClick={() => { if (hw.length) startPractice(shuffle(hw).slice(0, 15), 'Qiyin soʻzlar'); else toast(t('Soʻz kartochkasidagi yulduzchani bosib belgilang')); }}>
        <span className="sq2" style={{ background: 'var(--error-soft)', color: 'var(--error-ink)' }}><Ic n="target" /></span>
        <span className="grow col g4" style={{ textAlign: 'left' }}><b className="t15b">{t('Qiyin soʻzlar')}</b><span className="t13">{hw.length ? tn('# ta belgilangan', hw.length) : t('Yulduzcha bilan belgilang')}</span></span>
        <span className="chev2"><Ic n="chevRight" size={16} /></span>
      </button>
      <button className="qa2" onClick={() => nav.push({ k: 'forms', from: 'home' })}>
        <span className="sq2" style={{ background: 'var(--success-soft)', color: 'var(--success-ink)' }}><Ic n="layers" /></span>
        <span className="grow col g4" style={{ textAlign: 'left' }}><b className="t15b">{t(FM.title)}</b><span className="t13">{fDue ? tn('# ta takrorlash kutyapti', fDue) : tn('#/# yodlangan', fLearned, FM.items.length)}</span></span>
        <span className="chev2"><Ic n="chevRight" size={16} /></span>
      </button>
      <b className="t16b" style={{ fontSize: 18 }}>{t('Soʻz jangi')}</b>
      <div className="livebig">
        <button onClick={() => nav.push({ k: 'duel' })} style={{ background: 'linear-gradient(160deg,#0B1B3F,#163A7A 55%,#1A66F5)' }}>
          <Ic n="swords" className="i bgi" />
          <i><Ic n="swords" size={26} /></i>
          <span className="vsav"><MyAvatar size={34} /><b>VS</b><LetterAvatar n="?" c="#7A5200" size={34} /></span>
          <b>{t('Soʻz jangi')}</b><small>{t('1 ga 1 · doʻst, raqib yoki bot')}</small>
        </button>
      </div>
      {/* "Jonli ingliz tili" (podkast/kitob/kino, MAX) va Live stol MVP'da yo'q */}
      {lang && <LangSheet onClose={() => setLang(false)} />}
      {notif && <NotifSheet onClose={() => setNotif(false)} />}
    </>
  );
}
